import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const providersSelector = (state: RootState) => state.amwell.activeConsumer.providers;
export const providersListSelector = createSelector(providersSelector, p => p.list);
export const providerDetailsSelector = createSelector(providersSelector, p => p.details);

export const providersListDataSelector = createSelector(providersListSelector, l => l.data);
export const providersListDataErrorSelector = createSelector(providersListSelector, l => l.error);
export const providersListDataLoadingSelector = createSelector(
  providersListSelector,
  l => l.loading
);

export const providerDetailsDataSelector = createSelector(providerDetailsSelector, d => d.data);
export const providerDetailsDataErrorSelector = createSelector(
  providerDetailsSelector,
  d => d.errors.data
);
export const providerDetailsDataLoadingSelector = createSelector(
  providerDetailsSelector,
  d => d.loading.data
);
export const providerDetailsWereViewedSelector = createSelector(
  providerDetailsSelector,
  d => d.providerDetailsWereViewed
);

export const estimatedVisitCostDataSelector = createSelector(
  providerDetailsSelector,
  d => d.estimatedVisitCost
);
export const estimatedVisitCostDataErrorSelector = createSelector(
  providerDetailsSelector,
  d => d.errors.estimatedVisitCost
);
export const estimatedVisitCostDataLoadingSelector = createSelector(
  providerDetailsSelector,
  d => d.loading.estimatedVisitCost
);
